import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Sparkles, Check } from 'lucide-react';
import { APP_VERSION } from '../../config/version';

// Intentar importar changelog, si falla usar fallback
let CHANGELOG = [];
let getChangesSince = () => [];

try {
  const changelogModule = await import('../../config/changelog.js');
  CHANGELOG = changelogModule.CHANGELOG || [];
  getChangesSince = changelogModule.getChangesSince || (() => []);
} catch (e) {
  console.warn('Changelog no disponible');
}

const STORAGE_KEY = 'lastSeenVersion';

export const WhatsNewModal = () => {
  const [open, setOpen] = useState(false);
  const [newChanges, setNewChanges] = useState([]);

  useEffect(() => {
    // Verificar si hay novedades que mostrar
    const lastSeen = localStorage.getItem(STORAGE_KEY);
    
    // Si nunca vio nada o es versión diferente
    if (lastSeen !== APP_VERSION) {
      const changes = getChangesSince(lastSeen);
      if (changes.length > 0) {
        setNewChanges(changes);
        setOpen(true);
      } else {
        // No hay cambios pero actualizar la versión guardada
        localStorage.setItem(STORAGE_KEY, APP_VERSION);
      }
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, APP_VERSION);
    setOpen(false);
  };

  if (newChanges.length === 0) return null;

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg">
            <div className="p-2 rounded-lg bg-primary/10">
              <Sparkles className="h-5 w-5 text-primary" />
            </div>
            Novedades en v{APP_VERSION}
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-2 max-h-[400px] overflow-y-auto">
          {newChanges.map((release, idx) => (
            <div key={release.version} className={idx > 0 ? 'pt-4 border-t border-border' : ''}>
              {newChanges.length > 1 && (
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-0.5 rounded">
                    v{release.version}
                  </span>
                  <span className="text-xs text-muted-foreground">{release.title}</span>
                </div>
              )}
              <ul className="space-y-2">
                {release.changes.map((change, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm">
                    <Check className="h-4 w-4 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-muted-foreground">{change}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <DialogFooter>
          <Button onClick={handleClose} className="w-full">
            Entendido
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WhatsNewModal;
